import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

/* eslint-disable no-undef */
const requireComponent = require.context(
  '@/components', true, /\.vue$/
)

// Export a function that registers components with the app instance
export default function registerComponents(app) {
  requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
      camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
    )

    app.component(componentName, componentConfig.default || componentConfig)
  })
}
